import React from 'react'
import {Box, Button, Dialog, Typography} from "@mui/material";
import {Trans} from "@lingui/macro";

interface DeleteResearchProps {
    open: boolean
    onClose: () => void
    onClick: (id: string) => void
    data: any
}

interface DeleteResearchState {

}

export class DeleteResearchDialog extends React.Component<DeleteResearchProps, DeleteResearchState>
{
    render() {
        return(
            <Dialog open={this.props.open} onClose={this.props.onClose}>
                <Typography variant="h5" sx={{ml: 2, mt: 2}}>
                    <Trans id={'research.delete-research.title'}>
                        Attenzione
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 2}}>
                    <Trans id={'research.delete-research.body'}>
                        L'operazione è irreversibile e verranno eliminati anche i risultati relativi alla ricerca selezionata.
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 4}}>
                    <Trans>
                        Sicuro di voler eliminare la ricerca "{this.props.data.name}"?
                    </Trans>
                </Typography>
                <Box sx={{my: 2, mr: 2}} textAlign={"right"}>
                    <Button size="small"
                            onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 3,
                            }}
                            disableElevation
                    >
                        <Trans id="workflow.delete-workflow.abort">
                            Annulla
                        </Trans>
                    </Button>
                    <Button variant={"contained"}
                            disableElevation
                            sx={{
                                textTransform: "none",
                                color: "background.default",
                                bgcolor: "error.main"
                            }}
                            onClick={() => this.props.onClick(this.props.data.id)}
                    >
                        <Trans id="workflow.delete-workflow.delete">
                            Elimina
                        </Trans>
                    </Button>
                </Box>
            </Dialog>
        )
    }
}
